<a [href]="suggestion.url"
    tabindex="0"
    [attr.aria-label]="suggestion.title"
    class="suggestion"
    [ngClass]="{'suggestion--highlighted': suggestion.highlighted}"
    *ngFor="let suggestion of results | slice:0:MAX_LINES; let i = index">
    <div class="suggestion__content">
      <div class="suggestion__title" [innerHTML]="suggestion.title"></div>
      <div class="suggestion__type" *ngIf="suggestion.type" [innerHTML]="suggestion.type"></div>
    </div>
</a>

<!-- No results -->
<div *ngIf="!results?.length && query.length >= MIN_LENGTH && isResponseCompleted" class="suggestion suggestion--no-results">
  <div class="suggestion__content">
    {{ 'autoSuggest.NoResults' | translate }}
  </div>
</div>

<!-- Not long query -->
<div *ngIf="query && query.length < MIN_LENGTH" class="suggestion suggestion--no-results">
  <div class="suggestion__content">
    {{ 'autoSuggest.StartFrom' | translate }}
  </div>
</div>

<ng-content></ng-content>
